import {Moment} from 'moment';
import {Instituicao} from './instituicao.model';
import {ProjetoPropriedadeIntelectual} from './projeto-propriedade-intelectual.model';
import {ProjetoTipoClasse} from './projeto-tipo-classe.model';
import {RdaVersao} from './rda-versao.model';
import {Rda} from './rda.model';
import {TipoClasse} from './tipo-classe.model';
import {TipoProjeto} from './tipo-projeto.model';

export class Projeto {

  id: number;
  versao: RdaVersao;
  rda: Rda;
  identificacao: string;
  sigla: string;
  nome: string;
  dataInicio: Moment;
  dataFim: Moment;
  especificacao: string;
  trocaProjeto: boolean;
  empresaConveniada: Instituicao;
  tipoProjeto: TipoProjeto;
  projetoPropriedadesIntelectuais: ProjetoPropriedadeIntelectual[];
  dispendioProprio: boolean;
  proprio: boolean;
  compoeRda: boolean;
  projetoTipoClasse: ProjetoTipoClasse;
  classe: TipoClasse;

  constructor(init?: Partial<Projeto>) {
    Object.assign(this, init);
  }
}
